import styled from "styled-components";

export const HRDivider = styled.div`
    margin: 5px 0px;
    height: 1px;
    width: 100%;
    background: ${({ theme }) => theme.bg3};
`;